import React from 'react'
import { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { Button, Icon, Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useIsIndirectSyncSensorMode } from '@src/screens/OwnSensorOnboarding/hooks'
import { useIsActiveDexcom } from '@src/utils/hooks'

export interface ByosIntegrationWarningProps {
  thirdPartyWarning: boolean
}

export const ByosIntegrationWarning = ({ thirdPartyWarning }: ByosIntegrationWarningProps) => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation()
  const isIndirectSyncSensorMode = useIsIndirectSyncSensorMode()
  const isActiveDexcom = useIsActiveDexcom()

  if (!thirdPartyWarning) {
    return null
  }

  const iconName = 'wifi-x'
  const titleText = 'No Connection'
  const bodyText = 'Integrate your sensor with Nutrisense to review your data'
  const buttonText = 'Connect Sensor'

  const onButtonPress = () => {
    if (isIndirectSyncSensorMode) {
      return navigation.navigate('CheckConnection')
    }

    if (isActiveDexcom) {
      return navigation.navigate('DexcomSensorSettings')
    }

    navigation.navigate('CheckConnection')
  }

  return (
    <View style={styles.container}>
      <View style={styles.background} />
      <View style={styles.contentContainer}>
        <View style={styles.header}>
          <Icon name={iconName} />
          <Text type="regular" bold style={styles.textHeader}>
            {titleText}
          </Text>
        </View>
        <Text type="regular" style={styles.textBody}>
          {bodyText}
        </Text>
        <Button
          type="primary"
          size="small"
          style={styles.button}
          onPress={onButtonPress}
          accessibilityLabel="Next"
        >
          {buttonText}
        </Button>
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    position: 'absolute',
    top: '30%',
    left: '50%',
    width: 244,
    transform: [{ translateX: -120 }, { translateY: -50 }],
    height: 188,
  },
  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.4,
    borderRadius: 24,
    backgroundColor: 'theme.accent.citron',
  },
  contentContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    marginHorizontal: 16,
  },
  header: {
    marginTop: 16,
    alignItems: 'center',
    flexDirection: 'row',
  },
  textHeader: {
    textAlign: 'center',
    marginLeft: 4,
    color: 'theme.text.primary',
  },
  textBody: {
    textAlign: 'center',
    marginBottom: 12,
    color: 'theme.text.primary',
  },
  button: {
    marginBottom: 16,
  },
})
